import { useEffect, useState } from "react";

/**
 * True during a given minute of the local day. Defaults to 21:37.
 *
 * The legacy site evaluated `date('H:i') === '21:37'` once per page render, so it only
 * fired if you happened to load the page in that minute. This checks on an interval,
 * so an already-open tab lights up too.
 */
export function useSpecialTime(hour = 21, minute = 37): boolean {
  const [active, setActive] = useState(() => isNow(hour, minute));

  useEffect(() => {
    const check = () => setActive(isNow(hour, minute));
    check();
    const timer = setInterval(check, 10_000);
    return () => clearInterval(timer);
  }, [hour, minute]);

  return active;
}

function isNow(hour: number, minute: number): boolean {
  const now = new Date();
  return now.getHours() === hour && now.getMinutes() === minute;
}
